
import Vue from 'vue';
import { Box as VixBox, Toggle as VixToggle } from '@mx/vix';
import { bridge, api, env, encrypt, analytics } from '@/common';
import { objectToQuery } from '@mx/util/object-to-query';
import {
  RISKCONTROL_PARTNER_ID,
  verifyNo,
  PaymentScene,
  ShengxinProductsNameMap
} from '@/common/constant';
import { objectAssign } from '@mx/util/object-assign';
import AgreementDialog from '@/components/AgreementDialog.vue';
import TouchPayCell from './components/TouchPayCell.vue';
import { analyticConfig } from '@/config/analyticConfig';
import { monitor } from '@/common/monitor';

import TitleBar from '@/components/TitleBar.vue';
import toast from '@/service/toast';

export default Vue.extend({
  data() {
    return {
      DEFAULT_TIP: '去查看',
      config: {
        authentication: {} as IAuthentication,
        oneClickPay: {} as IOneClickPay,
        noPassPay: {} as INoPassPay,
        deductEntry: {} as IDeductEntry,
        touchPay: {} as ITouchPay,
        bioEntry: {} as IBioEntry,
        faq: {} as IFAQ,
        deductOrder: {} as IpaySequence,
        agreement: {},
        digitalCert: {} as DigitalCert,
        consumerProtection: {} as IFAQ,
        accountInsurance: {},
        familyCard: {},
        remitPayment: {},
        promopoint: {}
      } as IPaySettingsConfig,
      needSetPayhashInfo: true,
      pageAriaHidden: false, // 控制阅读模式下，页面是否可以选中，展示弹窗的时候不选中，有点击穿透事件
      setPayPasswordAppearId: '', // 设置支付密码 appear 订阅 ID
      isHarmony: env.isHarmony
    };
  },
  components: {
    VixBox,
    VixToggle,
    TouchPayCell,
    AgreementDialog,
    TitleBar,
  },
  created() {
    encrypt.load();
    env
      .initParamsOfSet()
      .catch(() => {})
      .finally(() => {
        // 团平台兜底流量进入支付设置页，直接重定向至支付管家，不再请求后端接口
        // this.queryPaySettings();
      });
    analytics.pv(analyticConfig.paySetting.cid, { scene: env.scene });
    // appear: 切回到当前容器时触发
    bridge.subscribe('appear', () => {
      // 订阅设置支密流程 appear 不处理 queryPaySettings
      if (!this.setPayPasswordAppearId) {
        // this.queryPaySettings();
      }
    });
    console.log(this.config);
    monitor.reportMetric('pay-settings-system', {
      isHarmony: env.isHarmony
    });
  },

  computed: {
    // 是否展示消保入口
    showSafeguardEntry(): boolean {
      return !!(
        this.config.consumerProtection &&
        this.config.consumerProtection.link &&
        this.config.consumerProtection.name
      );
    },

    // 是否展示省心支付产品模块
    showEasyPayModule(): boolean {
      return (this.isHarmony && this.config.noPassPay.ifShow) || !this.isHarmony;
    },

    // 小额免密的无障碍文案
    noPassPayLabel(): string {
      const { ifShow, tip = '', content = '' } = this.config.noPassPay as any;
      if (ifShow) {
        return `小额免密${tip},${content}`;
      }
      return '';
    },

    // 数字证书的无障碍文案
    digitalCertLabel(): string {
      const { ifShow, tip = '', content = '' } = this.config.digitalCert as any;
      if (ifShow) {
        return `${tip},${content}`;
      }
      return '';
    },

    // 极速支付的无障碍文案
    oneClickPayLabel(): string {
      const { ifShow, redDot = '', tip = '', content = '' } = this.config
        .oneClickPay as any;
      if (ifShow) {
        return `极速支付${redDot}${tip},${content}`;
      }
      return '';
    },
    // 积分抵扣的无障碍文案
    promopointLabel(): string {
      const { ifShow, desc = '', subTitle = '' } = this.config
        .promopoint as any;
      if (ifShow) {
        return `积分抵扣${desc},${subTitle}`;
      }
      return '';
    }
  },

  watch: {
    // 数字证书 MV 上报
    'config.digitalCert': {
      handler(val) {
        if (val.ifShow && val.tip && val.link) {
          analytics.mv(analyticConfig.paySetting.cfcaCert.mv);
        }
      },
      deep: true
    },
    // 消保模块 MV 上报
    'config.consumerProtection': {
      deep: true,
      handler(val) {
        if (val.name && val.link) {
          analytics.mv(analyticConfig.safeguard.mv);
        }
      }
    }
  },

  methods: {
    goBack() {
      KNB.closePage();
    },
    toAccountInsurance() {
      const link = this.config.accountInsurance.link || 'https://npay.meituan.com/resource/account-insurance/index.html?entry=wallet&ehwebview=1';
      bridge.openPage(
        link,
        1
      );
    },
    openTouchPay(pageTip: string, fingerType: string) {
      // tslint:disable-next-line:max-line-length
      const url = `${
        location.origin
      }/resource/pay-settings/touchPayVerifyPayhash.html?pageTip=${encodeURI(
        pageTip
      )}&finger_type=${fingerType}`;
      bridge.openPage(url);
    },
    queryPaySettings(message = '') {
      api
        .paypass({
          printType: env.biometricsInfoParams.printType,
          model_key: env.biometricsInfoParams.model_key,
          support_finger_type: env.biometricsInfoParams.support_finger_type,
          hardwareDetected: 1
        })
        .then((data) => {
          this.config = objectAssign(this.config, data);
          if (data.payhashInfo && data.payhashInfo.haspayhash) {
            this.needSetPayhashInfo = false;
          }
          // cat上报
          const isOpenNoMessage = sessionStorage.getItem('isOpenNoMessage');
          sessionStorage.clear();
          if (isOpenNoMessage === 'true') {
            if (this.config.touchPay.isOpen === false) {
              monitor.reportMetric('biology-no-message-payPass-False', {
                scene: env.scene
              });
            }
          }
          // 模块曝光
          this.moduleView();

          this.toastFingerMessage(message);
        })
        .finally(() => {
          // TTI 上报
          monitor.reportTTI();
        });
    },
    moduleView() {
      if (this.config.deductOrder && this.config.deductOrder.link) {
        analytics.mv(analyticConfig.paySetting.bid.showSquence, {
          reddot: this.config.deductOrder.redDot
        });
      }
      ['oneClickPay', 'mtScorePay'].forEach((item) => {
        if ((this.config as any)?.[item]?.ifShow) {
          analytics.mv((analyticConfig.shengxinProducts as any)[item].mv);
        }
      });
      ['deductEntry', 'familyCard'].forEach((item) => {
        const itemConfig = (this.config as any)?.[item];
        if (itemConfig && Object.keys(itemConfig).length) {
          analytics.mv((analyticConfig.shengxinProducts as any)[item].mv);
        }
      });
    },
    toastFingerMessage(message: string) {
      // 指纹支付关闭成功提示
      if (message) {
        toast.show('success', message);
        // cat上报成功数据
        monitor.reportMetric('biology-close-success', {
          scene: env.scene
        });
      }
      // 指纹支付开启提示
      const openMessage = localStorage.getItem('message');
      const ifFingerOpen = localStorage.getItem('ifFingerOpen');
      localStorage.clear();
      if (openMessage) {
        if (ifFingerOpen === 'true') {
          toast.show('success', openMessage);
          // cat上报成功数据
          monitor.reportMetric('biology-open-success', {
            scene: env.scene
          });
        } else {
          toast.show('error', openMessage);
          // cat上报失败数据
          monitor.captureMessage({
            name: '安卓开启touch-pay调用disable-touch-pay接口返回失败',
            msg: JSON.stringify({
              href: location.href,
              userAgent: navigator.userAgent,
              queryString: env.commonParams
            })
          });
        }
      }
    },
    clickItemAnalytics(item: string) {
      const { clickItem, clickNoPassPay } = analyticConfig.paySetting.bid;
      const bid = item === '小额免密' ? clickNoPassPay : clickItem;

      if (item === '扣款顺序') {
        analytics.click(bid, {
          from: 'pay-setting',
          item,
          scene: env.scene,
          reddot: this.config.deductOrder.redDot
        });
      } else if (item === this.config.consumerProtection.name) {
        analytics.click(analyticConfig.safeguard.mc);
      } else if (
        this.config &&
        this.config.digitalCert &&
        item === this.config.digitalCert.tip
      ) {
        analytics.click(analyticConfig.paySetting.cfcaCert.mc);
      } else {
        analytics.click(bid, {
          from: 'pay-setting',
          item,
          scene: env.scene
        });
        if (Object.keys(ShengxinProductsNameMap).indexOf(item) !== -1) {
          const productName = (ShengxinProductsNameMap as any)[item];
          analytics.click((analyticConfig.shengxinProducts as any)[productName].mc, {
            utm_source: -999
          }, {
            key: 'pay',
            cid: analyticConfig.paySetting.cid
          });
        }
      }
    },
    openLink(url: string, item: string): void {
      // 埋点
      this.clickItemAnalytics(item);
      bridge.openPage(url);
    },
    openPaypassSetting(payhashInfo: any): void {
      // 无支付密码时，接入支付密码设置服务：https://km.sankuai.com/page/22355527
      const bid = analyticConfig.paySetting.bid.clickItem;
      if (payhashInfo && !payhashInfo.haspayhash && this.needSetPayhashInfo) {
        bridge.subscribe(
          'appear',
          () => {
            setTimeout(() => {
              // 已订阅时，先将上一次订阅取消
              const appearId = this.setPayPasswordAppearId;
              if (appearId) {
                bridge.unSubscribe('appear', () => {}, appearId);
                this.setPayPasswordAppearId = '';
              }
            });
            setTimeout(() => {
              const getIsHashSet = new Promise<void>((resolve, reject) => {
                bridge.getStorage('isHashSet', (value) => {
                  if (Number(value) === 1) {
                    resolve();
                    return;
                  }
                  const isHashSet = window.localStorage.getItem('isHashSet');
                  if (Number(isHashSet) === 1) {
                    window.localStorage.removeItem('isHashSet');
                    resolve();
                    return;
                  }
                  // 判断 resultCode 与 resultData，展示弹窗引导用户点击确认支付
                  bridge.getResult(
                    (result) => {
                      if (result.resultCode === 10) {
                        resolve();
                        return;
                      }
                      reject(new Error('设置支付密码获取结果失败'));
                    },
                    (err) => {
                      reject(new Error('设置支付密码获取结果失败'));
                    }
                  );
                });
              });
              getIsHashSet
                .then(() => {
                  toast.show('success', '密码设置成功', 2000);
                  setTimeout(() => {
                    this.queryPaySettings();
                  }, 2000);
                })
                .catch((err) => {
                  toast.show('error', '支付密码未设置, 请重试', 2000);
                });
            }, 400);
          },
          (result) => {
            if (result && result.subId) {
              this.setPayPasswordAppearId = result.subId;
            }
            const qs = objectToQuery({
              verifyNo: verifyNo.wallet,
              partnerId: RISKCONTROL_PARTNER_ID,
              scene: PaymentScene.PaymentSceneWalletPassword,
              closeWebview: 1,
              exptFlag: 1
            });
            const url = `${
              location.origin
            }/resource/pass-verify/setting.html?${qs}`;
            analytics.click(bid, {
              item: '设置支付密码',
              scene: env.scene,
              from: 'pay-setting'
            });
            setTimeout(() => {
              bridge.openPage(url);
            }, 400);
          }
        );
      } else {
        analytics.click(bid, {
          item: '支付密码设置',
          scene: env.scene,
          from: 'pay-setting'
        });
        bridge.openPage('password.html');
      }
    },
    setTouchPaySuccessCallback(message: string) {
      this.queryPaySettings(message);
    },
    // 更新页面 aria-hidden 的状态
    updatePageAriaHidden(status: boolean) {
      this.pageAriaHidden = status;
    }
  }
});
